module.exports = __webpack_public_path__ + "static/img/advertisementPhoto.034161a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisementPhoto.png
// module id = Nyy6
// module chunks = 1